module.exports = __webpack_public_path__ + "01_glasses_black.f49c062e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/01_glasses_black.png
// module id = e17U
// module chunks = 0